import { render } from "./SettingsModal.vue?vue&type=template&id=4251f03e"
import script from "./SettingsModal.vue?vue&type=script&lang=js"
export * from "./SettingsModal.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__